import React, { type FC } from 'react';
import { xcss, Flex } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { GeneratingAnimation } from './generating-animation/index.tsx';
import messages from './messages.tsx';

type Props = {
	hasPadding?: boolean;
};

export const StreamingStatusBar: FC<Props> = ({ hasPadding = true }) => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={[baseContainerStyle, hasPadding ? withPaddingStyle : noPaddingStyle]}>
			<GeneratingAnimation alt={formatMessage(messages.generatingSuggestions)} />
		</Flex>
	);
};

const baseContainerStyle = xcss({
	alignItems: 'center',
	paddingBlockStart: 'space.150',
	paddingBlockEnd: 'space.150',
	gap: 'space.100',
});

const withPaddingStyle = xcss({
	paddingInline: 'space.150',
});

const noPaddingStyle = xcss({
	paddingInline: 'space.0',
});
